export const isLookupNotFoundError = (error: any) => {
  return error?.message?.statusCode === 404;
};
